export const InteractionEventPublisherToken = Symbol('InteractionEventPublisher');
export const DurationEventTrackerToken = Symbol('DurationEventTracker');
export const SingularEventPublisherToken = Symbol('SingularEventPublisher');
export const EventPublisherToken = Symbol('EventPublisherToken');
export const EnvironmentDetectorToken = Symbol('EnvironmentDetector');
export const SenderToken = Symbol('Sender');
